module.exports = __webpack_public_path__ + "static/img/10.12f733c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/8/zh/10.png
// module id = qbIW
// module chunks = 0